export const SET_IS_COUNTRY_EMERGENCY = "SET_IS_COUNTRY_EMERGENCY";
export const SET_IS_MY_VIDEO_CHOSEN = "SET_IS_MY_VIDEO_CHOSEN";
export const SET_MY_CONTENT = "SET_MY_CONTENT";
export const SET_READY_CONTENT = "SET_READY_CONTENT";
export const SET_LOADING = "SET_LOADING";
